package game

import view.Terminal

class CharSprite(
    val id: String,
    val width: Int = 1,
    val height: Int = 1,
    private val colOffset: Int = 0,
    private val rowOffset: Int = 0,
    val room: Room,
    val frames: List<CharSpriteFrame>,
    private val useBgColor: Boolean
) {
    val duration: Int
        get() = frames.map { it.duration }.sum()

    fun render(terminal: Terminal, col: Int, row: Int, frame: Int) {
        for (y in 0 until height) {
            for (x in 0 until width) {
                val terminalCol = col + x + colOffset
                val terminalRow = row + y + rowOffset
//                if (terminalCol in ROOM_LEFT_COL until ROOM_LEFT_COL + ROOM_WIDTH && terminalRow in ROOM_TOP_ROW until ROOM_TOP_ROW + ROOM_HEIGHT) {
                with(terminal.getChar(terminalCol, terminalRow)) {
                    val f = room[frames[frame].col + x, frames[frame].row + y]
                    if (f.char != 0) {
                        char = f.char
                        bgColor = if (useBgColor) {
                            f.bgColor
                        } else if (bgColor != f.fgColor) {
                            // Use background colour if it's not the same as the foreground colour
                            bgColor
                        } else {
                            // Oops! bgColour == fgColor. Use tile fgColor instead
                            fgColor
                        }

                        fgColor = f.fgColor
                    }
                }
//                }
            }
        }
    }
}

class CharSpriteFrame(
    val duration: Int = 0,
    val col: Int,
    val row: Int,
) {}